// app/javascript/ui_components/register.js

import TecladoCodigoController from "./controllers/teclado_codigo_controller"
import DeleteModalController from "./controllers/delete_modal_controller"
import FilterModalController from "./controllers/filter_modal_controller"
import MenuHubController from "./controllers/menu_hub_controller"
import MenuPersistController from "./controllers/menu_persist_controller"
import FavoritesController from "./controllers/favorites_controller"
import EmailEditorController from "./controllers/email_editor_controller"
import EmailFieldController from "./controllers/email_field_controller"
import FormTableDependentsController from "./controllers/form_table_dependents_controller"
import FlatpickrController from "./controllers/flatpickr_controller"
import CpfFieldController from "./controllers/cpf_field_controller"
import CpfCnpjMaskController from "./controllers/cpf_cnpj_mask_controller"
import CepFieldController from "./controllers/cep_field_controller"
import FacialFieldController from "./controllers/face_capture_controller"
import IpFieldController from "./controllers/ip_field_controller"
import RgFieldController from "./controllers/rg_field_controller"
import TelefoneFieldController from "./controllers/telefone_field_controller"
import DateRangeController from "./controllers/date_range_controller"
import PaymentFieldsController from "./controllers/payment_fields_controller"
import ValidadeCartaoController from "./controllers/validade_cartao_controller"
import MoneyFieldController from "./controllers/money_field_controller"
import LocationFieldController from "./controllers/location_field_controller"
import RemoteModalController from "./controllers/remote_modal_controller"
import RemoteSelectController from "./controllers/remote_select_controller"
import FilePreviewController from "./controllers/file_preview_controller"

import FormValidationController from "./controllers/form_validation_controller"

export function registerUiComponents(application) {
  application.register("teclado-codigo", TecladoCodigoController)
  application.register("delete-modal", DeleteModalController)
  application.register("filter-modal", FilterModalController)
  application.register("menu-hub", MenuHubController)
  application.register("menu-persist", MenuPersistController)
  application.register("favorites", FavoritesController)
  application.register("email-editor", EmailEditorController)
  application.register("email-field", EmailFieldController)
  application.register("form-table-dependents", FormTableDependentsController)
  application.register("flatpickr", FlatpickrController)
  application.register("cpf-field", CpfFieldController)
  application.register("cpf-cnpj-mask", CpfCnpjMaskController)
  application.register("cep-field", CepFieldController)
  application.register("face-capture", FacialFieldController)
  application.register("ip-field", IpFieldController)
  application.register("rg-field", RgFieldController)
  application.register("telefone-field", TelefoneFieldController)
  application.register("date-range", DateRangeController)
  application.register("payment-fields", PaymentFieldsController)
  application.register("validade-cartao", ValidadeCartaoController)
  application.register("money-field", MoneyFieldController)
  application.register("location-field", LocationFieldController)
  application.register("remote-modal", RemoteModalController)
  application.register("remote-select", RemoteSelectController)
  application.register("file-preview", FilePreviewController)
  application.register("form-validation", FormValidationController)
}
